import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      display: flex;\n      height: 100vh;\n      align-items: flex-start;\n      justify-content: center;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
import { css } from "@emotion/react";
var StageWrapper = /*#__PURE__*/ styled("div", {
    target: "e9awvit0"
})("position:relative;");
var StageContentContainer = /*#__PURE__*/ styled("div", {
    target: "e9awvit1"
})("width:100%;padding:0;", function(param) {
    var isAffiliate = param.isAffiliate;
    return isAffiliate && css(_templateObject());
}, " ", Theme.mq("sm"), "{margin:0 auto;background-color:transparent;}/* FIXME:This block causes layout issues with larger WidgetSearch,new type of StageContentContainer? */\n  ", Theme.mq("lg"), "{display:flex;height:29.375rem;align-items:center;}");
var StageCaption = /*#__PURE__*/ styled("div", {
    target: "e9awvit2"
})("background-color:", Theme.Color.natural0, ";display:inline-block;position:relative;width:100%;margin:1.875rem 0;", Theme.mq("sm"), "{width:auto;}", Theme.mq("md"), "{margin-top:0.625rem;margin-bottom:0.625rem;margin-right:0.625rem;padding:0.625rem 0.9375rem;}", Theme.mq("lg"), "{margin-top:1rem;margin-bottom:1rem;margin-right:1rem;}");
var StageLink = /*#__PURE__*/ styled("a", {
    target: "e9awvit3"
})("display:none;", Theme.mq("sm"), "{display:block;overflow:hidden;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);min-height:29.375rem;width:100vw;text-indent:-100em;}");
var SuppliersContentContainer = /*#__PURE__*/ styled("div", {
    target: "e9awvit4"
})("padding-bottom:2rem;");
var SupplierList = /*#__PURE__*/ styled("ul", {
    target: "e9awvit5"
})("height:auto;margin:0 auto;padding:0.85rem;display:flex;flex-wrap:wrap;justify-content:space-around;gap:1rem;", Theme.mq("sm"), "{border:0;min-height:3.52rem;}");
var SupplierListItem = /*#__PURE__*/ styled("li", {
    target: "e9awvit6"
})("svg{height:1.5rem;}");
var BadgesContainer = /*#__PURE__*/ styled("aside", {
    target: "e9awvit7"
})("position:absolute;bottom:1rem;right:1rem;z-index:1;display:flex;place-items:flex-end;gap:1rem;flex-direction:column;");
var TrustElement = /*#__PURE__*/ styled("div", {
    target: "e9awvit8"
})("display:inline-flex;padding:0.5rem;border-radius:", function(param) {
    var theme = param.theme;
    return theme.borderRadius.xs;
}, ";background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
export { BadgesContainer, StageContentContainer, StageCaption, StageLink, StageWrapper, SuppliersContentContainer, SupplierList, SupplierListItem, TrustElement };
